
<template>
  <v-app id="onZinn">
    <v-main>
      <v-container fluid>
        <v-card>
          <v-container fluid>
            <h2>Nr: {{ zinn.zinn_nr }}</h2>
            <span v-for="(zinntaalRecord, i) in zinn.zinntaal" :key="i">
              <br>
              <b>{{ zinntaalRecord.taal_code }}</b> <v-btn class="primary ma-2" small
                @click="saveZinntaal(zinntaalRecord)">Save</v-btn><br>
              <v-textarea 
                v-model="zinntaalRecord.zinntaal_oms" 
                :value=zinntaalRecord.zinntaal_oms 
                no-resize 
                rows="1"
                auto-grow 
                counter 
                label="Translation" 
                spellcheck="false"></v-textarea>
              <br>
            </span>
          </v-container>
        </v-card>
      </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['zinn_encrid'],
  data() {
    return {
      zinn: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/zinn/getZinn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getZinn"
          },
          getZinn: {
             zinn_encrid: this.zinn_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.zinn = res.data.getZinn;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveZinntaal(zinntaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/zinn/saveZinntaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveZinntaal"
          },
          saveZinntaal: {
            zinntaal: zinntaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveZinntaal.text,
              color: res.data.saveZinntaal.color
            });
          }
        })
    }
  }  

};

</script> 
